/**
 * Cache key construction utilities for the Dashboard framework.
 *
 * The partition key format is `{dashboardId}#{analysisId}` which supports
 * multiple dashboard types sharing the same FinnDashboardCache DynamoDB table.
 */

/**
 * Build a DynamoDB partition key for the dashboard cache.
 *
 * @param dashboardId - Plugin ID, e.g. 'spb-analytics'
 * @param analysisId  - Analysis identifier, e.g. 'finn-analysis+SP+2025-01-01_2025-01-07+2024-01-01_2024-01-07'
 * @returns Composite partition key string
 */
export function buildCacheKey(dashboardId: string, analysisId: string): string {
  return `${dashboardId}#${analysisId}`;
}

/**
 * Build the SPB Analytics analysis ID from filter parameters.
 *
 * Pattern: `finn-analysis+{product}+{tsd}_{ted}+{bsd}_{bed}`
 *
 * @param product       - 'SP' or 'SB'
 * @param targetStart   - Target start date (YYYY-MM-DD)
 * @param targetEnd     - Target end date (YYYY-MM-DD)
 * @param baselineStart - Baseline start date (YYYY-MM-DD)
 * @param baselineEnd   - Baseline end date (YYYY-MM-DD)
 * @returns Analysis ID string
 */
export function buildSPBAnalysisId(
  product: string,
  targetStart: string,
  targetEnd: string,
  baselineStart: string,
  baselineEnd: string
): string {
  return `finn-analysis+${product}+${targetStart}_${targetEnd}+${baselineStart}_${baselineEnd}`;
}
